import { useQueryClient } from '@tanstack/react-query'
import { useUserStore, useSubscriptionStore } from '@/state'
import store from '@/store'
import keycloak, { clearSsoSession } from '@/keycloak'

export const useLogout = () => {
  const queryClient = useQueryClient()
  const clearUser = useUserStore((state) => state.clearUser)
  const clearSubscription = useSubscriptionStore((state) => state.reset)

  const logout = async () => {
    // 1. Clear all React Query cache
    queryClient.clear()

    // 2. Clear Zustand stores
    clearUser()
    clearSubscription()

    // 3. Clear any localStorage/sessionStorage items. Note: keycloak-js 26
    // keeps its callback/PKCE state in LOCALstorage (kc-callback-*), which
    // the targeted removals here never touch; the kc- filter below is
    // belt-and-braces in case keycloak ever writes to sessionStorage.
    localStorage.removeItem('token')
    localStorage.removeItem('subscription-store') // if persisted
    clearSsoSession()
    Object.keys(sessionStorage)
      .filter((key) => !key.startsWith('kc-'))
      .forEach((key) => sessionStorage.removeItem(key))

    // 4. Reset the easy-peasy auth state too — otherwise App.tsx "Case 3"
    // (token in state but not in localStorage) re-persists the token and
    // silently undoes this logout.
    store.dispatch.auth.resetAuthState()

    // 5. Stop keycloak-js' in-memory session (refresh timer + tokens) so an
    // auto-refresh cannot re-adopt a token into the emptied localStorage
    // minutes after this logout. The Keycloak single logout (redirect) lives
    // only in authService.logout — the user-initiated path — so SideMenu's
    // double call cannot fire it twice; if that redirect is already in
    // flight, this clearToken is harmless.
    if (keycloak.didInitialize && keycloak.authenticated) {
      keycloak.clearToken()
    }
  }

  return { logout }
}
